/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/cache/interface */
//# sourceMappingURL=interface.mjs.map